import './BrandingLogo.scss';

export const BrandingLogo = ({ url }: { url: string }) => {
  return <img alt="Branding Logo" className="branding-logo" src={url} />;
};
